import React, { forwardRef } from 'react';
import PrimaryButton from '../../website/components/account-setup/shared/PrimaryButton';

const GradientButton = forwardRef(({ children, fullWidth, startIcon, endIcon, variant = 'success', ...props }, ref) => {
  return (
    <PrimaryButton
      ref={ref}
      buttonVariant={variant}
      {...props}
      style={{
        width: fullWidth ? '100%' : undefined,
        ...(props.style || {}),
      }}
    >
      {startIcon ? <span className="button-icon start">{startIcon}</span> : null}
      {children}
      {endIcon ? <span className="button-icon end">{endIcon}</span> : null}
    </PrimaryButton>
  );
});

GradientButton.displayName = 'GradientButton';

export default GradientButton;